import styled, {css} from 'styled-components'
import { IconFacebook } from '../_svgs/Facebook/Facebook'
import { IconInstagram } from '../_svgs/Instagram/Instagram'
import { IconPinterest } from '../_svgs/Pinterest/Pinterest'
import { IconYoutube } from '../_svgs/YouTube/YouTube'
import { IconX } from '../_svgs/X/X'
import { IconTikTok } from '../_svgs/TikTok/TikTok'

export const FooterSocial = () => {
  const handleIconClick = (e) => {
    trackFooterClick(e.currentTarget.href)
  }

  return (
    <>
      <FooterSocialContainer>
        <FooterSocialIcon>
          <IconLink
            href='https://www.facebook.com/SwansonHealth'
            className='cTest_footer_facebook-icon'
            data-target='facebook'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconFacebook styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
        <FooterSocialIcon>
          <IconLink
            href='https://instagram.com/swansonhealth'
            className='cTest_footer_instagram-icon'
            data-target='instagram'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconInstagram styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
        <FooterSocialIcon>
          <IconLink
            href='https://www.youtube.com/c/SwansonHealth'
            className='cTest_footer_youtube-icon'
            data-target='youtube'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconYoutube styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
        <FooterSocialIcon>
          <IconLink
            href='https://pinterest.com/swansonhealth/'
            className='cTest_footer_pinterest-icon'
            data-target='pinterest'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconPinterest styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
        <FooterSocialIcon>
          <IconLink
            href='https://twitter.com/swansonhealth'
            className='cTest_footer_twitter-icon'
            data-target='twitter'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconX styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
        <FooterSocialIcon>
          <IconLink
            href='https://www.tiktok.com/@swansonhealth'
            className='cTest_footer_instagram-icon'
            data-target='tiktok'
            target='_blank'
            rel='noopener noreferrer'
            onClick={handleIconClick}
          >
            <IconTikTok styles={css`
              display: flex;
              flex-shrink: 0;
            `}/>
          </IconLink>
        </FooterSocialIcon>
      </FooterSocialContainer>
    </>
  )
}

const FooterSocialContainer = styled.div`
  justify-content: center;
  display: flex;
`
const FooterSocialIcon = styled.div`
  padding-left: 13px;
  padding-right: 13px;
  border-right: 1px solid rgba(217, 217, 217, 0.5);
  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    border-right: none;
  }
`

const IconLink = styled.a`
  color: ${(props) => props.theme.white} !important;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 32px;
  height: 32px;
  &:hover {
    color: ${(props) => props.theme.brandedLtGreen} !important;
  }
`
